import { Component } from "react";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import { Button, CardContent, CardHeader, Box, Typography, Container } from "@mui/material";
import Toast from "../../components/Toast";
import Header from "../../components/Header";
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class ReceiptFooterScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toast: {
        open: false,
        message: "",
        severity: "success" 
      },
      editorState: EditorState.createEmpty(),
      footerContent: null,
      editorImages: []
    };      
  }

  componentDidMount() {
    this.loadFooterContent();
  }

loadFooterContent = async () => {
  const { status, data } = await API(this, "get", URL_PATH.getReceiptFooter, {
    hotel_id: this.props.selectedHotelId.id
  });

  console.log("API response:", status, data);

  if (data) {
    // Save to Redux
    this.props.setReceiptFooter(data);
    
    try {
      // Check if content is a string or already an object
      const content = typeof data.content === 'string' 
        ? JSON.parse(data.content) 
        : data.content;
      
      const contentState = convertFromRaw(content);
      this.setState({
        editorState: EditorState.createWithContent(contentState),
        footerContent: data
      });
    } catch (e) {
      console.error("Error parsing footer content:", e);
      // Fallback to empty content if parsing fails
      this.setState({
        editorState: EditorState.createEmpty(),
        footerContent: data
      });
    }
  }
};

  onEditorStateChange = (editorState) => {
    this.setState({ editorState });
  };

  handleImageUpload = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const url = reader.result;
        this.setState(prevState => ({
          editorImages: [...prevState.editorImages, { file, url }]
        }));
        resolve({ data: { link: url } });
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  saveFooter = async () => {
    const contentState = this.state.editorState.getCurrentContent();
    const rawContent = convertToRaw(contentState);
    console.log("rawContentrawContentrawContent",rawContent)
    const formData = new FormData();
    formData.append("hotel_id", this.props.selectedHotelId.id);
    formData.append("content", JSON.stringify(rawContent));
    
    // Append all editor images
    this.state.editorImages.forEach((image) => {
      formData.append(`images`, image.file);
    });
    
    try {
      const { status, message } = await API(
        this,
        "post",
        URL_PATH.saveReceiptFooter,
        formData
      );
      
      if (status === "success") {
        this.setState({
          toast: {
            open: true,
            message: "Footer saved successfully",
            severity: "success"
          },
          editorImages: [] // Clear uploaded images after save
        });
      }
    } catch (error) {
      this.setState({
        toast: {
          open: true,
          message: "Error saving footer",
          severity: "error"
        }
      });
    }
  };

  render() {
    return (
      <Container maxWidth="lg" className="py-5">
        <Box
          sx={{ 
            borderRadius: "10px",
            overflow: "hidden",
            bgcolor: "transparent",
            border: "1px solid #FFC857",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        > 
          <CardHeader
            title={<Header title="Receipt Footer Configuration" />}
            sx={{ pb: 2 }}
          />
          <CardContent>
            <Box mb={4}>
              <Typography variant="h6" gutterBottom sx={{ color: "white", mb: 2 }}>
                Footer Content
              </Typography>
              <Box sx={{ 
                border: "1px solid #555",
                borderRadius: 1,
                bgcolor: "background.paper",
                minHeight: 200,
                p: 2,
                width: "100%"
              }}>
                <Editor
                  editorState={this.state.editorState}
                  onEditorStateChange={this.onEditorStateChange}
                  toolbar={{
                    options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'link', 'embedded', 'image'],
                    image: {
                      uploadCallback: (file) => this.handleImageUpload(file),
                      alt: { present: true, mandatory: false },
                      defaultSize: { height: 'auto', width: '100%' },
                      inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg'
                    }
                  }}
                  editorStyle={{
                    minHeight: '200px',
                    border: '1px solid #ddd',
                    padding: '10px',
                    borderRadius: '4px'
                  }}
                />
              </Box>
            </Box>

            <Box mt={4} display="flex" justifyContent="flex-start">
              <Button
                variant="contained"
                onClick={this.saveFooter}
                size="large"
                sx={{
                  px: 4,
                  py: 1,
                  borderRadius: 1,
                  textTransform: "none",
                  fontWeight: 700,
                  bgcolor: "#FFC857",
                  "&:hover": {
                    bgcolor: "#E6B54E",
                  },
                }}
              >
                Save Footer
              </Button>
            </Box>
          </CardContent>
        </Box>

        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={() => this.setState({ 
            toast: { ...this.state.toast, open: false } 
          })}
        />
      </Container>
    );
  }
}

export default redux(ReceiptFooterScreen);